import {useEffect} from 'react';

import {useApiHooks} from '../../api-hook/api-hook';
import {UseHookType} from '../../api-hook/api-hook-type';

import {fetchReviewCompetitorBrands, fetchReviewCustomerBrands} from './review-competitors-api';
import {BrandCompareType, ReviewsCompetitorBrandsQueryType} from './review-competitors-type';

export function useReviewCompetitorBrands(
    options: ReviewsCompetitorBrandsQueryType,
    mainFilterKey: string
): UseHookType<Array<BrandCompareType>> {
    const {isInProgress, setIsInProgress, processError, setProcessError, result, setResult, reset} =
        useApiHooks<Array<BrandCompareType>>();

    const {
        mode,
        brandIds,
        companyIds,
        startDate,
        endDate,
        sentiments,
        sources,
        tags,
        phrases,
        topics,
        rating,
        withAnswers,
        withText,
        ableToReply,
        target,
        useDeleted,
        userTagsIds,
        aspectIds,
    } = options;

    useEffect(() => {
        setIsInProgress(true);

        fetchReviewCompetitorBrands(
            {
                mode,
                brandIds,
                startDate,
                endDate,
                sentiments,
                sources,
                tags,
                phrases,
                topics,
                rating,
                withAnswers,
                withText,
                ableToReply,
                target,
                useDeleted,
                companyIds,
                userTagsIds,
                aspectIds,
            },
            mainFilterKey
        )
            .then(setResult)
            .finally(() => setIsInProgress(false))
            .catch(setProcessError);
    }, [
        mode,
        brandIds,
        setIsInProgress,
        setProcessError,
        setResult,
        startDate,
        endDate,
        sentiments,
        sources,
        tags,
        phrases,
        topics,
        rating,
        withAnswers,
        withText,
        ableToReply,
        target,
        useDeleted,
        companyIds,
        userTagsIds,
        aspectIds,
        mainFilterKey,
    ]);

    return {isInProgress, processError, result, reset};
}

export function useReviewCustomerBrands(
    options: ReviewsCompetitorBrandsQueryType,
    mainFilterKey: string
): UseHookType<BrandCompareType> {
    const {isInProgress, setIsInProgress, processError, setProcessError, result, setResult, reset} =
        useApiHooks<BrandCompareType>();

    const {
        brandIds: compareBrandIds,
        startDate,
        endDate,
        sentiments,
        sources,
        tags,
        phrases,
        topics,
        rating,
        withAnswers,
        withText,
        ableToReply,
        target,
        useDeleted,
        userTagsIds,
        aspectIds,
    } = options;

    useEffect(() => {
        setIsInProgress(true);

        fetchReviewCustomerBrands(
            {
                startDate,
                endDate,
                sentiments,
                sources,
                tags,
                phrases,
                topics,
                rating,
                withAnswers,
                withText,
                ableToReply,
                target,
                useDeleted,
                userTagsIds,
                aspectIds,
            },
            mainFilterKey
        )
            .then(setResult)
            .finally(() => setIsInProgress(false))
            .catch(setProcessError);
    }, [
        compareBrandIds,
        mainFilterKey,
        setIsInProgress,
        setProcessError,
        setResult,
        startDate,
        endDate,
        sentiments,
        sources,
        tags,
        phrases,
        topics,
        rating,
        withAnswers,
        withText,
        ableToReply,
        target,
        useDeleted,
        userTagsIds,
        aspectIds,
    ]);

    return {isInProgress, processError, result, reset};
}
